<template>
  <TheCatcherComponent>
    <SwapModal
      v-if="tradeInProvider === TradeInProviders.BM"
      :image
      :initial-payload
      :intro
      :modal-name
      :price
      :price-without-trade-in
      :product-title
      :redirect-on-close-target
      :zone
      @confirmation="$emit('confirmation')"
      @continue="$emit('continue')"
    />
    <ApacTradeInModal
      v-else-if="tradeInProvider === TradeInProviders.APAC"
      :intro
      :modal-name
      :zone
    />
  </TheCatcherComponent>
</template>

<script setup lang="ts">
import type { LocationQuery } from 'vue-router'

import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import {
  TradeInProviders,
  useBuybackConfig,
} from '@backmarket/nuxt-layer-buyback/app/composables/config/useBuybackConfig'

import TheCatcherComponent from '~/scopes/buyback/components/BuybackErrorBoundary/BuybackErrorBoundary.vue'
import ApacTradeInModal from '~/scopes/tradein-apac/components/TradeInModal/TradeInModal.vue'

import SwapModal from '../SwapModal/SwapModal.vue'

export interface SwapModalProps {
  modalName: string
  redirectOnCloseTarget?: string | null
  zone: string
  price?: Price
  priceWithoutTradeIn?: Price
  intro?: 'atc' | 'plp'
  initialPayload?: LocationQuery
  image?: GetProductResponse['images'][number]
  productTitle?: string
}

withDefaults(defineProps<SwapModalProps>(), {
  redirectOnCloseTarget: null,
  initialPayload: undefined,
  intro: undefined,
  price: undefined,
  priceWithoutTradeIn: undefined,
  image: undefined,
  productTitle: undefined,
})

defineEmits(['confirmation', 'continue'])

const { tradeInProvider } = useBuybackConfig()
</script>
